import Promo1 from "../../img/promo1.webp"
import Promo2 from "../../img/pormo2.webp"
import Promo5 from "../../img/promo5.webp"
import Shawarma from '../../img/ImgProducts/shawarma.webp'
import Combo1 from '../../img/ImgProducts/Combo.webp'
import KidsCarne from '../../img/ImgProducts/kids.webp'
import KidsTomate from '../../img/ImgProducts/kidsTomate.webp'
import DeluxeDoble from '../../img/ImgProducts/deluxeDoble.webp'
import Classic from '../../img/ImgProducts/classic.webp'
import KidsQueso from '../../img/ImgProducts/kidsQueso.webp'
import NuggetsKids from '../../img/ImgProducts/nuggetsKids.webp'
import HotKids from '../../img/ImgProducts/hotDogKids.webp'
import DeluxeCarne from '../../img/ImgProducts/deluxeCarne.webp'
import Melt from '../../img/ImgProducts/cheddarMelt.webp'
import Bacon from '../../img/ImgProducts/baconClassic.webp'
import DobleClassic from '../../img/ImgProducts/dobleClassic.webp'
import TripleClassic from '../../img/ImgProducts/tripleClassic.webp'
import PolloSandwich from '../../img/ImgProducts/polloSandwich.webp'
import PolloCrispy from '../../img/ImgProducts/pollocCrispy.webp'
import Granjero from '../../img/ImgProducts/granjeroBacon.webp'
import BaconCheese from '../../img/ImgProducts/baconCheese.webp'
import BaconTriple from '../../img/ImgProducts/baconTriple.webp'
import BaconDoble from '../../img/ImgProducts/baconDoble.webp'
import GranjeroClassic from '../../img/ImgProducts/granjeroClassic.webp'
import Queen from '../../img/ImgProducts/queen.webp'
import King from '../../img/ImgProducts/king.webp'
import Champion from '../../img/ImgProducts/champion.webp'
import ChampionDoble from '../../img/ImgProducts/championDoble.webp'
import CrispyChampion from '../../img/ImgProducts/crispyChampion.webp'
import Shrimp from '../../img/ImgProducts/shrimp.webp'
import Plain from '../../img/ImgProducts/plane.webp'
import HotDog from '../../img/ImgProducts/hotDog.webp'
import HotBacon from '../../img/ImgProducts/hotBacon.webp'
import Fish from '../../img/ImgProducts/fish.webp'
import HotBox from '../../img/ImgProducts/hotBox.webp'
import BoxChicken from '../../img/ImgProducts/boxChicken.webp'
import duoGranjero from '../../img/ImgProducts/duoGranjero.webp'
import DuoBacon from '../../img/ImgProducts/baconDuo.webp'
import PcDuo from '../../img/ImgProducts/PcDuo.webp'
import ComboGran from '../../img/ImgProducts/grnajeroP.webp'
import HotHam from '../../img/ImgProducts/HotHam.webp'
import Pc3 from '../../img/ImgProducts/Pc3.webp'
import PromoBacon from '../../img/ImgProducts/PromoBacon.webp'
import Hpc from '../../img/ImgProducts/Hcp.webp'
import PromoGran from '../../img/ImgProducts/GranjeroPromo.webp'
import BaconClasic from '../../img/BaconClasic.webp'
import Carne from '../../img/carne.webp'
import DeluxeP from '../../img/deluxe+queso.webp'
import Deluxe2P from '../../img/dobledeluxecar.webp'
import img2 from '../../img/HotDogs/2.webp'
import img8 from '../../img/HotDogs/8.webp'
import Chichenshrimp from '../../img/ImgProducts/chickenShrimp.webp'
import Salchipapas from '../../img/ImgProducts/SALCHIPAPAS.webp'
import StreetBurger from '../../img/original-1AB79CA0-B9F1-4C87-B533-9EEF8CD4EAA0.jpeg'









export const descripcionesPlatos = {
  "390 - Kids": {
    disponible: true,

    productoImg: KidsTomate,
    descripcion: "Pan con ajonjolí, mayonesa, ketchup, pepinillo y tomate",
    precioS: "4.68",
    precioC: "6.98",
    bebida: ["7up","cocacola","Frescolita", ],
    polloOCarne: true,
    altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250, // opcional, si quieres controlar ancho también
    marginTop: 50,
    bottom: 50,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","Ketchup"]

    

  },
  "390 - Kids Carne o Pollo": {
    disponible: true,

    productoImg: KidsCarne,
    descripcion: "Pan con ajonjolí, mayonesa, ketchup, pepinillo.",
    precioS: "4.68",
    precioC: "6.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: true,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300 ,
    marginTop: 70,
    bottom: 40,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","Ketchup"]

    

  },
  "390 - Kids con Queso": {
   disponible: true,

    productoImg: KidsQueso,
    descripcion: "Pan con ajonjolí, mayonesa, ketchup, pepinillo y queso kraft.",
    precioS: "4.98",
    precioC: "7.26",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: true,
    altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250 ,
    marginTop: 50,
    bottom: 20,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","Ketchup"]

    

  },
  "390 - Deluxe Carne o Pollo": {
    disponible: true,
     
    productoImg: DeluxeCarne,
    descripcion: "PAN CON AJONJOLÍ,MAYONESA, KETCHUP,BBQ, MOSTAZA, SALSA TÁRTARA,PEPINILLO, CEBOLLA, TOMATE,LECHUGA, PAPAS (HOT CHIPS).",
    preparacion: " ",
    precioS: "6.38",
    precioC: "9.78",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: true,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300,// opcional, si quieres controlar ancho también
    marginTop: 20,
    bottom: 0,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Pepinillos","Lechuga","Ketchup"]

    

  },
  "390 - Deluxe Doble": {
    disponible: true,
     
    productoImg: DeluxeDoble,
    descripcion: "PAN CON AJONJOLÍ,MAYONESA, KETCHUP,BBQ, MOSTAZA, SALSA TÁRTARA,PEPINILLO, CEBOLLA, TOMATE,LECHUGA, PAPAS (HOT CHIPS).",
    preparacion: " ",
    precioS: "9.28",
    precioC: "12.48",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250, // opcional, si quieres controlar ancho también
    marginTop: 40,
    bottom: 60,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Pepinillos","Lechuga","Ketchup"]

    

  },
  "390 - Cheddar Melt": {
    disponible: true,
     
    productoImg: Melt,
    descripcion: "CEBOLLA Y TOCINETA TROCEADA COCIDA AL GRILL, QUESO FUNDIDO, SALSA DE CEBOLLA DULCE, CARNE",
    preparacion: " ",
    precioS: "3.99",
    precioC: "6.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 70,
    bottom: 70,
    ingredientes: ["Cebolla Dulce","Cebolla"]

    

  },
  "390 - Carne o Pollo Classic": {
    disponible: true,
     
    productoImg: Classic,
    descripcion: "PAN CON AJONJOLÍ, MAYONESA, KETCHUP, BBQ, MOSTAZA, SALSA TÁRTARA, PEPINILLO, CEBOLLA, TOMATE, LECHUGA, QUESO KRAFT, TOCINETA, HUEVO, PAPAS (HOT CHIPS)",
    preparacion: " ",
    precioS: "7.98",
    precioC: "11.38",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: true,
     altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 10,
    bottom: -20,   
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Pepinillos","Lechuga","Ketchup"]

    

    

  },
  "390 - Bacon Classic": {
    disponible: true,
     
    productoImg: Bacon,
    descripcion: "MAYONESA, KETCHUP, BBQ, PEPINILLOS, CEBOLLA, TOMATE, LECHUGA, CARNE O POLLO, DOBLE QUESO KRAFT, DOBLE TOCINETA, SALSA TARTARA.",
    preparacion: " ",
    precioS: "7.98",
    precioC: "11.38",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250, // opcional, si quieres controlar ancho también
    marginTop: 0,
    bottom: 0,
        ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Pepinillos","Lechuga","Ketchup"]


    

  },
  "390 - Doble Classic": {
    disponible: true,
     
    productoImg: DobleClassic,
    descripcion: "PAN CON AJONJOLÍ, MAYONESA, KETCHUP, BBQ, MOSTAZA, SALSA TÁRTARA, PEPINILLO, CEBOLLA, TOMATE, LECHUGA, QUESO KRAFT, TOCINETA, HUEVO, PAPAS (HOT CHIPS)",
    preparacion: " ",
    precioS: "9.98",
    precioC: "12.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 10,
    bottom: 20,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Pepinillos","Lechuga","Ketchup"]


    

  },
  "390 - Triple Classic": {
    disponible: true,
     
    productoImg: TripleClassic,
    descripcion: "PAN CON AJONJOLÍ, MAYONESA, KETCHUP, BBQ, MOSTAZA, SALSA TÁRTARA, PEPINILLO, CEBOLLA, TOMATE, LECHUGA, QUESO KRAFT, TOCINETA, HUEVO, PAPAS (HOT CHIPS)",
    preparacion: " ",
    precioS: "12.98",
    precioC: "15.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 0,
    bottom:10,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Pepinillos","Lechuga","Ketchup"]


    

  },
  "390 - Pollo Sandwinch": {
    disponible: true,
     
    productoImg: PolloSandwich,
    descripcion: "PAN CON AJONJOLÍ, MAYONESA, TOMATE, LECHUGA, QUESO KRAFT, TOCINETA",
    preparacion: " ",
    precioS: "5.98",
    precioC: "8.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 20,
    bottom: -10,
    ingredientes: ["Mayonesa","Tomate","Lechuga"]


    

  },
  "390 - Pollo Cripsy": {
    disponible: true,
     
    productoImg: PolloCrispy,
    descripcion: "PAN CON AJONJOLÍ, MAYONESA, TOMATE, LECHUGA, MILANESA EMPANIZADA, QUESO Y TOCINETA.",
    preparacion: " ",
    precioS: "8.98",
    precioC: "12.78",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 20,
    bottom: 20,
    ingredientes: ["Mayonesa","Tomate","Lechuga"]


    

  },
  "390 - Granjero Bacon Cheese": {
    disponible: true,
     
    productoImg: Granjero,
    descripcion: "PAN CON AJONJOLÍ, CRUJIENTE GRANJERO, KRAFT QUESO, QUESO FUNDIDO, TOCINETA.",
    preparacion: " ",
    precioS: "8.98",
    precioC: "11.68",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 10,
    bottom: -10,
    ingredientes: ["Tocineta","Queso Kraft", "Queso Fundido"]

    

  },
  "390 - Granjero Classic": {
    disponible: true,
     
    productoImg: GranjeroClassic,
    descripcion: "CRUJIENTE GRANJERO, MAYONESA, TOMATE, LECHUGA, KRAFT QUESO, SALSA TÁRTARA, TOCINETA.",
    preparacion: " ",
    precioS: "7.98",
    precioC: "10.58",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 0,
    bottom: -10,
    ingredientes: ["Mayonesa","Salsa Tartara","Tomate","Lechuga"]


    

  },
  "390 - Bacon Cheese": {
    disponible: true,
     
    productoImg: BaconCheese,
    descripcion: "CARNE, PAN CON AJONJOLÍ, QUESO KRAFT, TOCINETA, QUESO FUNDIDO.",
    preparacion: " ",
    precioS: "7.27",
    precioC: "9.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 10,
    bottom: 10,
    ingredientes: []

    

  },
  "390 - Bacon Cheese Doble": {
    disponible: true,
     
    productoImg: BaconDoble,
    descripcion: "Doble CARNE, PAN CON AJONJOLÍ, Doble QUESO KRAFT, TOCINETA, QUESO FUNDIDO.",
    preparacion: " ",
    precioS: "9.98",
    precioC: "12.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 0,
    bottom: -10,
    ingredientes: []

    

  },
  "390 - Bacon Cheese Triple": {
    disponible: true,
     
    productoImg: BaconTriple,
    descripcion: "triple CARNE, PAN CON AJONJOLÍ, triple QUESO KRAFT, TOCINETA, QUESO FUNDIDO.",
    preparacion: " ",
    precioS: "12.98",
    precioC: "15.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 0,
    bottom: -10,
    ingredientes: []

    

  },
  "390 - Queen Burguer": {
    disponible: true,
     
    productoImg: Queen,
    descripcion: "CARNE, POLLO, LOMO DE CERDO AHUMADO Y CHORIZO, PAN CON AJONJOLÍ, MAYONESA, KETCHUP, BBQ, MOSTAZA, SALSA TÁRTARA, PEPINILLO, CEBOLLA, TOMATE, LECHUGA, DOBLE QUESO KRAFT, TOCINETA, HUEVO, PAPAS (HOT CHIPS).",
    preparacion: " ",
    precioS: "15.98",
    precioC: "18.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 0,
    bottom: -10,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Pepinillos","Lechuga","Cebolla","Salsa Tartara","Ketchup"]

    

  },
  "390 - King Burguer": {
    disponible: true,
     
    productoImg: King,
    descripcion: "DOBLE CARNE MAS POLLO, PAN CON AJONJOLÍ, MAYONESA, KETCHUP, BBQ, MOSTAZA, 2 SALSA TÁRTARA, PEPINILLO, CEBOLLA, TOMATE, LECHUGA, TRIPLE QUESO KRAFT, 12 TIRAS TOCINETA, 3 HUEVOS, PAPAS (HOT CHIPS).",
    preparacion: " ",
    precioS: "18.48",
    precioC: "23.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
   altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 0,
    bottom: 0,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Pepinillos","Lechuga","Cebolla","Salsa Tartara","Ketchup"]

    

  },
  "390 - Champion Grill": {
   disponible: true,
     
    productoImg: Champion,
    descripcion: "CARNE, PAN CON AJONJOLÍ, SALSA DE CEBOLLA DULCE, CHAMPIÑON Y CEBOLLA GRILLADA, TOCINETA, QUESO AMARILLO Y QUESO FUNDIDO.",
    preparacion: " ",
    precioS: "8.38",
    precioC: "11.88",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 10,
    bottom: -10,
    ingredientes: ["Salsa de cebolla dulce","Cebolla grillada","Champiñon"]

    

  },
  "390 - Champion Grill Doble": {
   disponible: true,
     
    productoImg: ChampionDoble,
    descripcion: "CARNE, PAN CON AJONJOLÍ, SALSA DE CEBOLLA DULCE, CHAMPIÑON Y CEBOLLA GRILLADA, TOCINETA, QUESO AMARILLO Y QUESO FUNDIDO.",
    preparacion: " ",
    precioS: "10.98",
    precioC: "13.88",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 0,
    bottom: -10,
    ingredientes: ["Salsa de cebolla dulce","Cebolla grillada","Champiñon"]

    

  },
  "390 - Crispy Champion": {
   disponible: true,
     
    productoImg: CrispyChampion,
    descripcion: "POLLO CRISPY, CHAMPIÑONES, CEBOLLA Y TOCINETA, COCIDASAL GRILL, QUESO KRAFT, QUESO FUNDIDO, SALSA DE CEBOLLA DULCE..",
    preparacion: " ",
    precioS: "8.98",
    precioC: "11.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
     altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 10,
    bottom: -10,
    ingredientes: ["Salsa de cebolla dulce","Cebolla","Champiñon"]

    

  },
  "390 - Chicken Shrimp": {
    disponible: true,
     
    productoImg: Chichenshrimp,
    descripcion: "POLLO Y CAMARONES AL AJILLO, CEBOLLA, TOMATE LECHUGA, SALSA TARTARA.",
    preparacion: " ",
    precioS: "9.48",
    precioC: "12.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
     altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 0,
    bottom: -10,
    ingredientes: ["Tomate","Cebolla ","Tomate","Lechuga","Salsa Tartara"]

    

  },
  "390 - Fish & Shrimp": {
    disponible: true,
     
    productoImg: Fish,
    descripcion: "SALSA DE AJO, CEBOLLA MORADA, TOMATE, LECHUGA, MERLUZA EMPANIZADA, CAMARONES AL AJILLO, SALSA TARTARA.",
    preparacion: " ",
    precioS: "9.98",
    precioC: "12.78",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
     altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 70,
    bottom: 50,
    ingredientes: ["Tomate","Cebolla morada ","Tomate","Lechuga","Salsa Tartara"]
    

  },
  "390 - Plain": {
    disponible: true,
     
    productoImg: Plain,
    descripcion: "Pan con ajonjolí carne o pollo",
    preparacion: " ",
    precioS: "2.98",
    precioC: "5.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: true,
     altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250, // opcional, si quieres controlar ancho también
    marginTop: 0,
    bottom: 70,

    

  },
 
 
};

export const entradas = {
  "390 - Hot Dog Kids": {
   disponible: true,
     
    productoImg: HotKids,
    descripcion: " mayonesa, ketchup mostaza, papas (hot chips).",
    preparacion: " ",
    precioS: "2.38",
    precioC: "4.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
     altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250, // opcional, si quieres controlar ancho también
    marginTop: 20,
    bottom: 50,
        ingredientes: ["Mayonesa"," Mostaza","Ketchup","Papitas"]

    

    

  },
  "390 - Nuggets Kids": {
   disponible: true,

    productoImg: NuggetsKids,
    descripcion: "5 piezas de nuggets, papas fritas regulares.",
    precioS: "4.68",
    precioC: "6.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
     altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250, // opcional, si quieres controlar ancho también
    marginTop: 50,
    bottom: 30,

    

  },
  "390 - Hot Dog Classic": {
    disponible: true,

    productoImg: HotDog,
    descripcion: " PAN, SALCHICHA, CEBOLLA, REPOLLO, MAYONESA, KETCHUP, BBQ, MOSTAZA,PAPITAS, QUESO AMARILLO,SALSA DE AJO, MAÍZ.",
    precioS: "3.45",
    precioC: "5.48",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 70,
    bottom: 60,
        ingredientes: ["Mayonesa","Cebolla","Ketchup","Repollo","BBQ","Mostaza","Salsa de ajo"]

    

    

  },
   "390 - Hot Dog Cheddar Melt": {
    disponible: true,

    productoImg: img2,
    descripcion: "Salchicha wiener meister, cebolla y tocineta troceada cocida al grill, queso fundido, salsa de cebolla dulce.",
    precioS: "3.68",
    precioC: "6.38",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 70,
    bottom: 60,
        ingredientes: ["Mayonesa","Cebolla","Ketchup","Repollo","BBQ","Mostaza","Salsa de ajo"]

    

    

  },
  "390 - Hot Dog Especial": {
    disponible: true,

    productoImg: img8,
    descripcion: "Salchicha wiener meister, cebolla, papitas, mayonesa, ketchup, mostaza, queso de año.",
    precioS: "2.69",
    precioC: "5.48",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 70,
    bottom: 60,
        ingredientes: ["Mayonesa","Cebolla","Ketchup","Repollo","BBQ","Mostaza","Salsa de ajo"]

    

    

  },
  "Hot Dog Classic + Bacon": {
    disponible: true,

    productoImg: HotBacon,
    descripcion: " Salchicha wiener meister, cebolla, repollo, mayonesa, ketchup, BBQ, mostaza, papitas, queso amarillo, salsa de ajo, maíz, tocineta.",
    precioS: "3.58",
    precioC: "6.48",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
     altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250, // opcional, si quieres controlar ancho también
    marginTop: 50,
    bottom: 10,
        ingredientes: ["Mayonesa","Cebolla","Ketchup","Repollo","BBQ","Mostaza","Salsa de ajo","Maiz","Cebolla Dulce"]

    

    

  },
  "Hot Dog Shrimp": {
   disponible: true,

    productoImg: Shrimp,
    descripcion: " Camarones al ajillo, cebolla, peregil, salsa tartara, papas (hot chips).",
    precioS: "4.58",
    precioC: "7.98",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
     altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250, // opcional, si quieres controlar ancho también
    marginTop: 20,
    bottom: 0,
    ingredientes: ["cebolla","Peregil","Salsa Tartara"]

    
    

    

  },
  "390 - Shawarma": {
    disponible: true,
     
    productoImg: Shawarma,
    descripcion: "mayonesa, ketchup, bbq, mostaza, cebolla, tomate,lechuga, maiz, carne y pollo, papas de perro y salsa de ajo.",
    preparacion: " ",
    precioS: "7.54",
    precioC: "10.34",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250, // opcional, si quieres controlar ancho también
    marginTop: 30,
    bottom: 10,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Ketchup","Maiz","Papitas","Salsa de ajo","Lechuga"]

    

  },
  "390 - Salchipapas": {
    disponible: true,
     
    productoImg: Salchipapas,
    descripcion: "Papás Fritas, Salchichas, Mayonesa, Ketchup, BBQ, Mostaza, Queso Amarillo, Nuguets de Pollo",
    preparacion: " ",
    precioS: "7.99",
    precioC: "8.99",
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 250, // opcional, si quieres controlar ancho también
    marginTop: 30,
    bottom: 10,
    ingredientes: ["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Ketchup","Maiz","Papitas","Salsa de ajo","Lechuga"]

    

  },

};

export const extrasH = {
  "Papas regulares": {
    
    precio: "1.78"
  },
  "Papas grandes": {
    
    precio: "2.58"
  },
  "Maxi Papas": {
    
    precio: "4.98"
  },
  " Maxi Papas Bacon Cheese": {
    
    precio: "6.98"
  },
  /*
   "Aros de cebolla ": {
    precio: "2.48"

  },
  */
  "Queso": {
    precio: "0.85"
  },
  "Queso Fundido": {
    precio: "0.78"
  },
  "Queso de año": {
     precio: "0.35"
  },
  "Pollo": {
    precio: "1.98"
  },
  "Pollo Crispy": {
    precio: "1.98"
  },
  "Carne": {
    precio: "2.58"
  },
  "Lomo de Cerdo": {
    precio: "1.98"
  },
  "Chorizo": {
      precio: "2.68"
  },
  "Tocineta": {
      precio: "1.00"
  },
  "Huevo": {
    precio: "0.68"

  },
   "Salsa Tartara": {
    precio: "0.68"

  },
   "Salsa Picante": {
    precio: "0.85"

  },
   "Cebolla Dulce": {
    precio: "0.48"

  },
    "Papitas (HOT CHIPS)": {
    precio: "0.48"

  },
    "Champiñon": {
    precio: "1.20"

  },
    "Chipotle": {
    precio: "0.58"

  },
   
};

export const extrasHot = {
  "Papas regulares": {
    
    precio: "1.78"
  },
  "Papas grandes": {
    
    precio: "2.58"
  },
  "Maxi Papas": {
    
    precio: "4.98"
  },
  " Maxi Papas Bacon Cheese": {
    
    precio: "6.98"
  },
  /*
   "Aros de cebolla ": {
    precio: "2.48"

  },
  */
  "Queso": {
    precio: "0.85"
  },
  "Queso Fundido": {
    precio: "0.78"
  },
  "Queso de año": {
     precio: "0.35"
  },
  "Chorizo": {
      precio: "2.68"
  },
  "Tocineta": {
      precio: "1.00"
  },
  "Huevo": {
    precio: "0.68"
  },
   "Salsa Tartara": {
    precio: "0.68"

  },
   "Salsa Picante": {
    precio: "0.85"

  },
   "Cebolla Dulce": {
    precio: "0.48"

  },
    "Papitas (HOT CHIPS)": {
    precio: "0.48"

  },
    "Champiñon": {
    precio: "1.20"

  },
    "Chipotle": {
    precio: "0.58"

  },
   
};

export const extras = {
  "Papas regulares": {
    disponible: true,
    
    modal: false,
    precio: "1.78"
  },
  "Papas grandes": {
    disponible: true,
    
    modal: false,
    precio: "2.58"
  },
  "Maxi Papas": {
    disponible: true,
    
    modal: false,
    precio: "4.98"
  },
  " Maxi Papas Bacon Cheese": {
    disponible: true,
    
    modal: false,
    precio: "6.98"
  },
  
  "Aros de cebolla ": {
   disponible: false,
    modal: false,
    precio: "2.48"

  },
  
  "Cocacola 355ml": {
    disponible: true,
    
    modal: false,
    precio: "1.45"
  },
  "7up 355ml": {
    disponible: true,
    
    modal: false,
    precio: "1.45"
  },
  "Frescolita 355ml": {
    disponible: true,
    
    modal: false,
    precio: "1.45"
  },
  "Lipton 500ml": {
    disponible: true,
    
    modal: false,
    precio: "2.50"
  },
  "Lipton 1.5lt": {
    disponible: true,
    
    modal: false,
    precio: "6.50"
  },
  "Cocacola 1.5lt": {
    disponible: true,
    
    modal: false,
    precio: "3.00"
  },
  "Cocacola 1lt": {
    disponible: true,
    
    modal: false,
    precio: "2.00"
  },
  
  
};

export const modals = [

  {
    nombre: "PromoPL",
    tipo: "lm", // identificador especial
    img: null,   // PromoDuo tiene varias imágenes internas, no necesita una sola
    botones: [], // PromoDuo maneja sus propios botones internos
    promos: [] ,
    bebida: false,  // PromoDuo maneja sus propios objetos
    preparacion: true,

  },
  {
    nombre: "PromoDuo",
    tipo: "duo", // identificador especial
    img: null,   // PromoDuo tiene varias imágenes internas, no necesita una sola
    botones: [], // PromoDuo maneja sus propios botones internos
    promos: [], 
    bebida: false,  // PromoDuo maneja sus propios objetos
    preparacion: false,
  },
  {
    nombre: "390 Street Burger",
    img: StreetBurger,
    botones: ["Sola", "Con papas"],
    promos: [
      {
        nombre: "390 Street Burger",
        precio: "2.99",
        tipoSeleccion: "Sola",
      },
      {
        nombre: "390 Street Burger",
        precio: "3.99",
        tipoSeleccion: "Con papas",
      },
    ],
    bebida: false,
    preparacion: false,
  },
  {
    nombre: "Promo HotDog",
    tipo: "hd",
    img: null,
    botones: [],
    promos: [],
    bebida: false,
    preparacion: false,
  },
  {
    nombre: "Promo1",
    img: Promo1,
    cantidad: 4, 
    opcionesPorUnidad: ["Carne", "Pollo"], 
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "390 Promo Classic x4",
        precio: "39.99",
      },
    ],
    bebida: true,
    preparacion: true,

  },
  {
    nombre: "Promo Hot Dogs",
    img: Promo2,
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "Promo Hot Dogs Especial",
        precio: "12.99",
      },
    ],
    bebida: true,
    preparacion: false,
  },
  {
    nombre: "Promo Carne",
    img: Carne,
    tipo: "mj",
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "390 - Carne",
        precio: "6.48",
      },
    ],
    bebida: false,
    preparacion: false,
  },
  {
    nombre: "Promo Bacon Clasic",
    img: BaconClasic,
    tipo: "mj",
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "390 - Bacon Clasic",
        precio: "6.48",
      },
    ],
    bebida: false,
    preparacion: false,
  },
  {
    nombre: "Promo Deluxe",
    img: DeluxeP,
    tipo: "mj",
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "390 - Deluxe",
        precio: "5.48",
      },
    ],
    bebida: false,
    preparacion: false,
  },
  {
    nombre: "Promo Deluxe Doble",
    img: Deluxe2P,
    tipo: "mj",
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "390 - Deluxe Doble",
        precio: "7.48",
      },
    ],
    bebida: false,
    preparacion: false,
  },
 
  
  {
    nombre: "Promo3",
    img: Pc3,
    cantidad: 3, 
    opcionesPorUnidad: ["Carne", "Pollo"], 
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "390 Promo Classic x3",
        precio: "30.98",
      },
    ],
    bebida: true,
    preparacion: true,

  },
  {
    nombre: "Promo4",
    img: PromoBacon,
    opcionesPorUnidad: ["Carne", "Pollo"], 
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "390 Bacon Cheese ",
        precio: "26.99",
      },
    ],
    bebida: true,
    preparacion: false,

  },
  
   {
    nombre: "Promo6",
    img: Hpc,
    cantidad: 4, 
    opcionesPorUnidad: ["Carne", "Pollo"], 
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "390 Hamburguesas C/P",
        precio: "27.98",
      },
    ],
    bebida: true,
    preparacion: true,

  },
  {
    nombre: "Promo7",
    img: PromoGran,
    opcionesPorUnidad: ["Carne", "Pollo"], 
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "390 Promo Granjero",
        precio: "37.98",
      },
    ],
    bebida: true,
    preparacion: false,

  },
   {
    nombre: "Promo8",
    img: Promo5,
    opcionesPorUnidad: ["Carne", "Pollo"], 
    botones: ["Lo quiero"],
    promos: [
      {
        nombre: "390 Promo Bacon cheese Doble",
        precio: "46.98",
      },
    ],
    bebida: true,
    preparacion: false,

  },
  
];

export const ArmRoll = [
    {
      nombre: "Base",
      option: [
      {
        nombre: "Arroz + Nori",
        precio: "1.99",
      },
            {
        nombre: "Platano + Nori",
        precio: "1.99",
      },
            {
        nombre: "Nori sin arroz",
        precio: "1.99",
      },
    ]
    },
    {
      nombre: "Proteinas",
      option: [
      {
        nombre: "Atún",
        precio: "2.99",
      },
      {
        nombre: "Cangrejo(Kani)",
        precio: "2.99",
      },
      {
        nombre: "Salmón",
        precio: "2.99",
      },
      {
        nombre: "Camarones",
        precio: "2.99",
      },
    ]
    },
    {
      nombre: "Rellenos",
      option: [
      {
        nombre: "Aguacate",
        precio: "0.70",
      },
      {
        nombre: "Cebollin)",
        precio: "0.50",
      },
      {
        nombre: "Pepino",
        precio: "0.50",
      },
      {
        nombre: "Queso crema",
        precio: "0.99",
      },
      {
        nombre: "Mango",
        precio: "0.50",
      },
    ]
    },
    {
      nombre: "Toppings",
      option: [
        {
        nombre: "Ensalada Dinamita",
        precio: "2.99",
      },
      {
        nombre: "Tartar de Atún",
        precio: "2.99",
      },
      {
        nombre: "Tartar de Salmón",
        precio: "2.99",
      },
      {
        nombre: "Ensalada de Kani",
        precio: "2.99",
      },
      {
        nombre: "Salmón",
        precio: "2.99",
      },
      {
        nombre: "Atún",
        precio: "2.99",
      },
       {
        nombre: "Camarones Tempura",
        precio: "1.99",
      },
      {
        nombre: "Platano",
        precio: "0.80",
      },
      {
        nombre: "Aguacate",
        precio: "0.70",
      },
      
      
    ]
    },
   
]

export const combos = {
 
  
  "390 - Box Chicken": {
    disponible: true,
     
    productoImg: BoxChicken,
    descripcion: "390 Granjero + 390 Nuggets + Papas fritas regulares",
    bebida: ["7up 500ml","cocacola 1lt"],
    polloOCarne: false,
    preparacion: false,
    cantidadBebidas: 0,
     precio: "4.98",
    precioC: "12.98",
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 30,
    bottom: 70,


    

  },
  " 390 - Hot Box": {
    disponible: true,
     
    productoImg: HotBox,
    descripcion: "390 HOT dog + 390 nuggets + papas fritas regulares",
    precio: "4.98",
    bebida: ["7up 500ml","cocacola 1lt"],
    polloOCarne: false,
    preparacion: false,
    cantidadBebidas: 0,
    precioC: "12.98",
    altoImg: 250, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 20,
    bottom: 30,


    

  },
"390 - Classic Duo": {
  disponible: true,
  productoImg: PcDuo,
  descripcion:
    "DOS HAMBURGUESAS, DOS PAPAS REGULARES y BEBIDA INCLUIDA",
  precio: "20.98",
  cantidad: 2,  // 👈 número de hamburguesas
  bebida: ["7up","cocacola","Frescolita", ],    
  cantidadBebidasPorUnidad: 1, // 👈 UNA bebida por hamburguesa
  polloOCarne: false,
  preparacion: true, // 👈 debe activar el modo de preparaciones múltiples
  altoImg: 300,
  anchoImg: 300,
  marginTop: 30,
  bottom: 60,
},

  "390 - Bacon Cheese Duo": {
    disponible: true,

    productoImg: DuoBacon,
     descripcion: " DOS HAMBURGUESAS, DOS PAPAS REGULARES, PANES CON AJONJOLÍ, QUESO KRAFT, TOCINETA, QUESO FUNDIDO Y BEBIDA INCLUIDA",
    precio: "17.98",
    cantidad: 2,
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    preparacion: false,
    cantidadBebidas: 2, 
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 30,
    bottom: 70,



    

  },
  "390 - Granjero Duo": {
    disponible: true,

    productoImg: duoGranjero,
     descripcion: " DOS HAMBURGUESAS, DOS PAPAS REGULARES, PANES CON AJONJOLÍ, CRUJIENTE GRANJERO, KRAFT QUESO, QUESO FUNDIDO, TOCINETA Y BEBIDA INCLUIDA",
    precio: "20.48",
    cantidad: 2,
    bebida: ["7up","cocacola","Frescolita", ],    
    polloOCarne: false,
    preparacion: false,
    cantidadBebidas: 2, 
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 300, // opcional, si quieres controlar ancho también
    marginTop: 30,
    bottom: 70,


    

  },
  
  "390 - Granjero + Hot Dog": {
    disponible: true,

    productoImg: HotHam,
     descripcion: " 390 granjero, 390 - hot dog especial y  DOS PAPAS REGULARES.",
    precio: "6.98",
    polloOCarne: false,
    preparacion: false,
    cantidadBebidas: 0, 
    altoImg: 300, // <-- nuevo campo para altura
    anchoImg: 350, // opcional, si quieres controlar ancho también
    marginTop: 80,
    bottom: 30,



    

  },
  "390 - Combo Granjero": {
    disponible: true,

    productoImg: ComboGran,

     descripcion: " 390 granjero, 390 - hot dog especial y  DOS PAPAS REGULARES.",
    precio: "37.98",
    bebida: ["Frescolita 1lt","Cocacola 1lt","7up 1lt"],
    polloOCarne: false,
    preparacion: false,
    cantidadBebidas: 1, 
    altoImg: 400, // <-- nuevo campo para altura
    anchoImg: 400, // opcional, si quieres controlar ancho también
    marginTop: 70,
    bottom: 140,



    

  },

  
  
};

